module.exports = "../static/media/logo.3d661cbb.png";